export default "__VITE_ASSET__BTrXM1Si__"